import styled from "styled-components";
import {GameBodyBox} from "./game-body.box";

export const GameDetailHistoryBodyBox = styled(GameBodyBox)`
    > iframe {
      background-color: white;
      color: black;
    }
    
`